export const config = {
	clientSecret: "IUfqlYgUGsfGgFT2We3cluyZG2API014BIAtejv2",
	clientId: 2,
	PUSHER_APP_ID: "675286",
	PUSHER_APP_KEY: "112f84b4bff67fe0c535",
	PUSHER_APP_SECRET: "d7dff03961d2117d9f8f",
	PUSHER_APP_CLUSTER: "us2",
};
